import store from '../store'

export default function wxJsapiAuth(config, url) {
  const { appId, timestamp, nonceStr, signature } = config

  return new Promise(function (resolve, reject) {
    wx.config({
      appId: appId,
      timestamp: timestamp,
      nonceStr: nonceStr,
      signature: signature,
      jsApiList: [
        'getLocation'
      ]
    })
    wx.ready(function () {
      resolve(1)
    })
    wx.error(function (res) {
      reject(res)
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/wxjsapiauth.js